import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _DragAndDropZone;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var DragAndDropZone = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_DragAndDropZone = /*#__PURE__*/function (_Component) {
  function DragAndDropZone() {
    var _this2;
    _classCallCheck(this, DragAndDropZone);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, DragAndDropZone, [].concat(args));
    _defineProperty(_this2, "state", {
      toRender: false
    });
    return _this2;
  }
  _inherits(DragAndDropZone, _Component);
  return _createClass(DragAndDropZone, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles({
        toRender: this.shouldRender()
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles({
        toRender: this.shouldRender()
      });
    }
  }, {
    key: "shouldRender",
    value: function shouldRender() {
      var _this$props = this.props,
        inSidebar = _this$props.inSidebar,
        sidebarOpen = _this$props.sidebarOpen,
        inStimulus = _this$props.inStimulus,
        location = _this$props.location,
        draggingOver = _this$props.draggingOver,
        draggingAboveHalf = _this$props.draggingAboveHalf,
        dropIntoEmptyStimulus = _this$props.dropIntoEmptyStimulus;
      if (inSidebar && !sidebarOpen) {
        return false;
      }
      if (inStimulus) {
        if (location === 'above') {
          return draggingOver && draggingAboveHalf && !dropIntoEmptyStimulus;
        } else if (location === 'below') {
          return draggingOver && !draggingAboveHalf && !dropIntoEmptyStimulus;
        } else if (location === 'in') {
          return draggingOver && dropIntoEmptyStimulus;
        }
      } else if (location === 'above') {
        return draggingOver && draggingAboveHalf;
      } else if (location === 'below') {
        return draggingOver && !draggingAboveHalf;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var wrapperClass = !this.shouldRender() ? 'wrapper hide' : 'wrapper';
      return jsx("div", {
        className: wrapperClass,
        css: this.props.styles.wrapper
      }, jsx("div", {
        css: this.props.styles.dropZoneStyle
      }, t('Drop Question Here')));
    }
  }]);
}(Component), _defineProperty(_DragAndDropZone, "displayName", 'DragAndDropZone'), _defineProperty(_DragAndDropZone, "componentId", "Quizzes".concat(_DragAndDropZone.displayName)), _defineProperty(_DragAndDropZone, "propTypes", {
  draggingAboveHalf: PropTypes.bool.isRequired,
  draggingOver: PropTypes.bool.isRequired,
  dropIntoEmptyStimulus: PropTypes.bool,
  inSidebar: PropTypes.bool,
  inStimulus: PropTypes.bool,
  location: PropTypes.oneOf(['above', 'below', 'in']).isRequired,
  sidebarOpen: PropTypes.bool,
  makeStyles: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_DragAndDropZone, "defaultProps", {
  draggingAboveHalf: false,
  draggingOver: false,
  dropIntoEmptyStimulus: false,
  inSidebar: false,
  inStimulus: false,
  sidebarOpen: true
}), _DragAndDropZone)) || _class);
export default DragAndDropZone;